/**
 * IBAN helpers: normalisation, MOD-97 checksum validation and masked display.
 */

export const normalizeIban = (value: string): string =>
  value.replace(/[\s-]/g, '').toUpperCase();

export const isValidIban = (value: string): boolean => {
  const iban = normalizeIban(value);
  if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{10,30}$/.test(iban)) return false;

  const rearranged = iban.slice(4) + iban.slice(0, 4);
  const numeric = rearranged.replace(/[A-Z]/g, (c) => String(c.charCodeAt(0) - 55));

  // MOD-97 computed in chunks to avoid big integer overflow
  let remainder = 0;
  for (let i = 0; i < numeric.length; i += 7) {
    remainder = Number(String(remainder) + numeric.slice(i, i + 7)) % 97;
  }
  return remainder === 1;
};

export const formatIban = (value: string): string =>
  normalizeIban(value).replace(/(.{4})/g, '$1 ').trim();

export const maskIban = (value: string): string => {
  const iban = normalizeIban(value);
  if (iban.length < 8) return iban;
  const visibleStart = iban.slice(0, 2);
  const visibleEnd = iban.slice(-4);
  const hidden = '*'.repeat(Math.max(0, iban.length - 6));
  return formatIban(`${visibleStart}${hidden}${visibleEnd}`);
};
